import { useMemo } from 'react';

import { useSearchParams } from 'react-router-dom';
import { ButtonMantine, Group } from 'ui';

import { useCampaignModalLayoutContext } from '../../../../routes/management/campaignModalLayout';
import { Editor } from '../../components/Editor/CampaignEditor';
import { NavLinks, navLinkCreator } from '../../components/Editor/NavLinks/NavLinks';
import { EditorSplitButton } from '../../components/Publish/EditorSplitButton';
import { CampaignDetails } from '../Settings/CampaignDetails/CampaignDetails';

const campaignCreateRoutes = navLinkCreator({
  label: 'General Details',
  path: 'create',
});

const campaignPageLinkRoutes = navLinkCreator({
  label: 'Page Links',
  path: 'links',
  disabled: () => true,
});

const donationSettingsRoutes = navLinkCreator({
  label: 'Payment Settings',
  path: 'payment-settings',
  disabled: () => true,
});

export const CAMPAIGN_NAME_MAP = {
  campaign: 'Crowdfunding',
  athon: 'A-thon',
  event: 'Ticketed Event',
};

const CreateCampaign = () => {
  const { setIsCloseable, setCloseButtonRef } = useCampaignModalLayoutContext();

  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');

  const title = useMemo(() => {
    if (!type) return 'New Campaign';
    const campaignType = CAMPAIGN_NAME_MAP[type];
    return `New ${campaignType}`;
  }, [type]);

  return (
    <Editor
      onDirty={(isDirty) => {
        setIsCloseable?.(!isDirty);
      }}
      setWarningRef={setCloseButtonRef}
      header={
        <Editor.Header title={title}>
          <Group>
            <ButtonMantine size="md" variant="subtle" disabled>
              Preview Page
            </ButtonMantine>
            <EditorSplitButton />
          </Group>
        </Editor.Header>
      }
      navbar={
        <Editor.Navbar>
          <NavLinks
            routes={[campaignCreateRoutes, campaignPageLinkRoutes, donationSettingsRoutes]}
          />
        </Editor.Navbar>
      }
    >
      <CampaignDetails />
    </Editor>
  );
};

export { CreateCampaign };
